/**
 * Utility function to handle Firebase authentication errors and return user-friendly messages
 * @param error - The Firebase authentication error
 * @param provider - The authentication provider (e.g., 'Google', 'GitHub')
 * @returns User-friendly error message
 */
export const handleAuthError = (error: any, provider: string = 'authentication'): string => {
  switch (error.code) {
    case 'auth/user-disabled':
      return 'This account has been disabled. Please contact support.';
    
    case 'auth/popup-closed-by-user':
      return 'Sign-in was cancelled. Please try again.';
    
    case 'auth/popup-blocked':
      return 'Pop-up was blocked. Please allow pop-ups and try again.';
    
    case 'auth/network-request-failed':
      return 'Network error. Please check your connection and try again.';
    
    case 'auth/too-many-requests':
      return 'Too many sign-in attempts. Please try again later.';
    
    case 'auth/operation-not-allowed':
      return `${provider} sign-in is not enabled. Please contact support.`;
    
    case 'auth/account-exists-with-different-credential':
      return 'An account already exists with the same email address but different sign-in credentials.';
    
    case 'auth/invalid-credential':
      return 'Invalid credentials. Please try again.';
    
    case 'auth/user-not-found':
      return 'No account found with this email address.';
    
    case 'auth/wrong-password':
      return 'Incorrect password. Please try again.';
    
    case 'auth/email-already-in-use':
      return 'This email is already in use.';
    
    case 'auth/weak-password':
      return 'Password is too weak. Please choose a stronger password.';
    
    case 'auth/invalid-email':
      return 'Invalid email address. Please check your email and try again.';
    
    case 'auth/user-token-expired':
      return 'Your session has expired. Please sign in again.';
    
    case 'auth/requires-recent-login':
      return 'This operation requires recent authentication. Please sign in again.';
    
    default:
      return `Failed to sign in with ${provider}. Please try again.`;
  }
};
